function getScrollBarWidth () {
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";
    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild (inner);
    document.body.appendChild (outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2) { w2 = outer.clientWidth; }
    document.body.removeChild (outer);
    return (w1 - w2);
};
(function($){
    // scrollbar corrections
    var scrollbarWidth = getScrollBarWidth();
    $('.hamburger-nav__bg').css('right', scrollbarWidth);
    $('.close, .hamburger-nav__body').on('click', function(e) {
        hamburgerOut();
    });
    $('#header-secondary-menu-toggle, .hamburger-trigger').on('click', function(e) {
        e.preventDefault();
        hamburgerIn();
    });
    // prevent menu from closing when clicked, only underlay should close the menu
    $('.hamburger-nav__content').on('click', function(e) {
        e.stopPropagation();
    });
    var width, duration;
    function setInfo() {
        width = $('.hamburger-nav__content').outerWidth();
        duration = width > 600 ? 0.45 : 0.35;
    }
    function hamburgerIn() {
        setInfo();
        $('.hamburger-nav').css('visibility', 'visible');
        $('body').addClass('noscroll').css('padding-right', scrollbarWidth);
        $('.site-header').css('padding-right', scrollbarWidth);
        new TimelineMax()
            .to($('.hamburger-nav__underlay'), 0.3, {opacity: 0.5, ease: Expo.easeNone}, 0)
            .to($('.hamburger-nav__bg'), duration, {marginRight: 0, opacity: 1, ease: Expo.easeOut}, 0.15)
            .to($('.hamburger-nav__content'), duration, {marginRight: 0, opacity: 1, ease: Expo.easeOut}, 0.15)
            .to($('.close', '.hamburger-nav'), 1, {opacity: 1, ease: Expo.easeNone}, duration)
    }
    function hamburgerOut() {
        setInfo();
        new TimelineMax({onComplete: function(){
            $('.hamburger-nav').css('visibility', 'hidden');
            $('body, .site-header').removeClass('noscroll').css('padding-right', '');
        }})
            .to($('.hamburger-nav__underlay'), 0.3, {opacity: 0, ease: Expo.easeNone}, 0.15)
            .to($('.hamburger-nav__bg'), duration, {marginRight: -width, opacity: 0, ease: Expo.easeOut}, 0)
            .to($('.hamburger-nav__content'), duration, {marginRight: -width, opacity: 0, ease: Expo.easeOut}, 0)
            .to($('.close', '.hamburger-nav'), duration, {opacity: 0, ease: Expo.easeNone}, 0)
    }
})(jQuery);
